var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKnowledge = function SvgKnowledge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F2F0",
    d: "M2.625 8.56h13.148A20.497 20.497 0 0 1 36.27 29.054v18.274a2.25 2.25 0 0 1-2.25 2.25H3.244a2.87 2.87 0 0 1-2.869-2.873V10.81a2.25 2.25 0 0 1 2.25-2.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M9.791 2.313a1.406 1.406 0 0 0-1.406 1.406v31.667a4.52 4.52 0 0 1 2.848-.906H39.75V3.719a1.406 1.406 0 0 0-1.406-1.406zm-1.406 35.88a2.84 2.84 0 0 1 .745-1.229 2.83 2.83 0 0 1 2.09-.797h29.374a.844.844 0 0 0 .843-.843V3.719A3.094 3.094 0 0 0 38.345.625H9.79a3.094 3.094 0 0 0-3.093 3.094v34.258a4.522 4.522 0 0 0 4.535 5.544h27.11a3.094 3.094 0 0 0 3.094-3.093v-1.395a.844.844 0 0 0-.843-.844H11.719a.844.844 0 1 0 0 1.687H39.75v.552a1.406 1.406 0 0 1-1.406 1.406H11.193a2.836 2.836 0 0 1-2.9-2.452.84.84 0 0 0 .092-.383z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M12.746 1.469c0-.466.378-.844.844-.844h6.96c.466 0 .844.378.844.844v15.656a.844.844 0 0 1-1.395.64l-2.929-2.526-2.929 2.525a.844.844 0 0 1-1.395-.639zm1.688.843v12.972l2.085-1.798a.844.844 0 0 1 1.102 0l2.085 1.798V2.313z",
    clipRule: "evenodd"
  })));
};
export default SvgKnowledge;